import { Component, OnInit, Input, Output,EventEmitter, SimpleChange, OnChanges, OnDestroy } from '@angular/core';
import { TextospredefinidosService } from '../_services/textospredefinidos.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-formulariotextos',
  templateUrl: 'formulariotextos.component.html'
})
export class FormulariotextosComponent implements OnInit, OnChanges, OnDestroy {

  @Input() idObservacion: any;
  @Input() idTipo: any;

  @Output() onChangeObservacion = new EventEmitter<boolean>();
  @Output() onCloseObservacion = new EventEmitter<number>();

  subscription: Subscription;

  observacion : {
    descripcion: string
  };
  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  constructor(private textosPredefinidosService:TextospredefinidosService) { }



  

  ngOnInit() {

    if (this.idObservacion != 0){
      this.getObservacion(this.idObservacion);
    }
    else{
      this.observacion.descripcion = '';
   
    }
  }

  ngOnDestroy(){
  //  this.subscription.unsubscribe();
  }
  
  getObservacion(id: number){

    this.textosPredefinidosService.getObservacion(id).subscribe(
      data => {
        if (data){
            this.observacion = data[0];
        }
      }
    );
  }


  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['idObservacion']){
      this.idObservacion = changes['idObservacion'].currentValue;
    }

    if (this.idObservacion != 0){
        this.getObservacion(this.idObservacion);
    }
    else{
      this.observacion['descripcion'] = '';
   
    }

  }

  onSubmit(a,b){

    let nuevoTexto = a.form.value.descripcion ;

    if (this.idObservacion === 0){ // -Si es nuevo
     
        this.textosPredefinidosService.setObservacion(this.idTipo, nuevoTexto).subscribe(
          () => {
              this.onChangeObservacion.emit(true);
          }
        );

   }else{ // -Si estamos editando
    this.textosPredefinidosService.updateObservacion(this.idObservacion,nuevoTexto).subscribe(
      data => {this.onChangeObservacion.emit(true);})

   }
  }

  cerrarObservacion(destino:number){

    this.cerrarVentana(destino);
  }

  cerrarVentana(destino:number){

    this.onCloseObservacion.emit(destino);
  }

}



// WEBPACK FOOTER //
// ./src/app/textospredefinidos/formulariotextos.component.ts